module.exports = __webpack_public_path__ + "80d0d024fe8378fc8fe55a5efd444b8b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-footer/sp-footer.html
// module id = 1105
// module chunks = 0